export var GrowthBookFeatures;
(function (GrowthBookFeatures) {
    GrowthBookFeatures["BackgroundEffects"] = "background_effects";
    GrowthBookFeatures["MobileGroupUI"] = "mobile_group_ui";
    GrowthBookFeatures["Locations"] = "locations";
    GrowthBookFeatures["LocationsBadge"] = "locations_badge";
    GrowthBookFeatures["DashboardWhatsNew"] = "feat-cs-9631-whats-new";
    GrowthBookFeatures["Voyce"] = "voyce_billing";
    GrowthBookFeatures["BillingSectionForClinic"] = "feat-cs-12540-billing-section-clinic";
    GrowthBookFeatures["TeleconsentPercentageScroll"] = "feat_cs_13614_teleconsent_percentage_scroll";
    GrowthBookFeatures["PatientQueueRefresh"] = "feat_cs_16503_patient_queue_refresh";
    GrowthBookFeatures["IsGraphQLAvailable"] = "realtime_use_graphql_endpoint";
    // https://app.growthbook.io/features/CS-17924_Show_Clinic_Subscription_Plan_Toggle#overview
    GrowthBookFeatures["ShowClinicSubscriptionPlan"] = "CS-17924_Show_Clinic_Subscription_Plan_Toggle";
    //https://app.growthbook.io/features/feat_cs_18827_clinic_account_sign_up
    GrowthBookFeatures["ClinicSignUpPath"] = "feat_cs_18827_clinic_account_sign_up";
    GrowthBookFeatures["SharedRoomsGroupAccess"] = "feat_cs-19038_shared_rooms_groups";
    GrowthBookFeatures["ClosedCaptions"] = "prod_759_closed_captions_og";
    GrowthBookFeatures["PatientSearch"] = "pe_3830_patient_search";
    GrowthBookFeatures["HideTelehealthShop"] = "pe_4023_hide_telehealth_shop";
    GrowthBookFeatures["HideProviderJoinEventTracking"] = "pe_4285_hide_provider_join_event_tracking";
    GrowthBookFeatures["HideProviderOnlineStatus"] = "pe_4341_hide_provider_online_status";
    // https://doxyme.atlassian.net/browse/PE-4423
    GrowthBookFeatures["BackToLandingPage"] = "pe_4423_back_to_landing_page";
    GrowthBookFeatures["ShowClinicBranding"] = "PE-4447_show_clnic_branding_tab_clnic_settings";
    GrowthBookFeatures["GroupRoomAccess"] = "feat_pe_4429_group_room_access";
    GrowthBookFeatures["OgAnnualCancellationToUserpilot"] = "feat-prod-5016-og-annual-cancellation-to-userpilot";
})(GrowthBookFeatures || (GrowthBookFeatures = {}));
